/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hasupcomingeventserror3Inputs */

const en_hasupcomingeventserror3 = /** @type {(inputs: Hasupcomingeventserror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are still upcoming events here. Cancel them first or wait until they are over.`)
};

const de_hasupcomingeventserror3 = /** @type {(inputs: Hasupcomingeventserror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier stehen noch kommende Events an. Sag sie zuerst ab oder warte, bis sie vorbei sind.`)
};

/**
* | output |
* | --- |
* | "There are still upcoming events here. Cancel them first or wait until they are over." |
*
* @param {Hasupcomingeventserror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const hasupcomingeventserror3 = /** @type {((inputs?: Hasupcomingeventserror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hasupcomingeventserror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hasupcomingeventserror3(inputs)
	return de_hasupcomingeventserror3(inputs)
});
export { hasupcomingeventserror3 as "hasUpcomingEventsError" }